<template>
  <slot></slot>
</template>

<script>
export default {
  name: 'ProductFooter'
}
</script>
